"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SASQViewComponent = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    fetchParameters,
    history,
    id,
    location,
    match,
    path,
    ViewComponent,
    viewQueryNamespaceGenerator = _ref2 => {
      let {
        namespace,
        componentId,
        id: passedId
      } = _ref2;
      const queryNamespace = [namespace, 'SASQ'];
      if (componentId) {
        queryNamespace.push(componentId);
      }
      queryNamespace.push('view');
      queryNamespace.push(passedId);
      return queryNamespace;
    },
    ...props
  } = _ref;
  const {
    0: namespace
  } = (0, _core.useNamespace)();

  // If itemEndpoint is available, use that, otherwise use standard endpoint
  const endpoint = fetchParameters?.itemEndpoint ?? fetchParameters?.endpoint;
  const ky = (0, _core.useOkapiKy)();
  const {
    data = {},
    ...rest
  } = (0, _reactQuery.useQuery)(viewQueryNamespaceGenerator({
    componentId: id,
    namespace,
    endpoint,
    id: match?.params?.id,
    match
  }), () => ky(`${endpoint}/${match?.params?.id}`).json(), {
    enabled: !!match?.params?.id
  });
  (0, _react.useImperativeHandle)(ref, () => ({
    queryProps: {
      data,
      ...rest
    }
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ViewComponent, {
    onClose: () => history.push(`${path}${location.search}`),
    queryProps: {
      ...rest
    },
    resource: data,
    ...props
  });
});
SASQViewComponent.propTypes = {
  fetchParameters: _propTypes.default.object,
  history: _propTypes.default.object,
  id: _propTypes.default.string,
  location: _propTypes.default.object,
  match: _propTypes.default.object,
  path: _propTypes.default.string.isRequired,
  ViewComponent: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node])
};
var _default = exports.default = SASQViewComponent;